/*

  ______  _____   ______ _______  ______
 |_____/ |     | |  ____ |______ |_____/
 |    \_ |_____| |_____| |______ |    \_

 vehicle sales system

(c) 2006 - 2019 TCE <TCE-ITDevelopers@toyota-ce.com>

Licensed under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License.
You may obtain a copy of the License at

http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software
distributed under the License is distributed on an "AS IS" BASIS,
WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
See the License for the specific language governing permissions and
limitations under the License.

*/

(function () {
    "use strict";

    angular
        .module("ROGER")

        //
        .controller("SalesOrderRequestModelChangeController", [
            "$scope", "$http", "$sessionStorage", "$user", "$oidc", "$routeParams", "$shoppingCart", "$location", "$messageBox",
            function ($scope, $http, $sessionStorage, user, oidc, $routeParams, $shoppingCart, $location, $messageBox) {

                const catalog = "catalog";
                const eta = "eta";

                var catalogApis = {
                    catalog: "model-catalog",
                    eta: "model-eta-catalog"
                };

                $scope.$storage = $sessionStorage;
                $scope.salesOrderRequestId = $routeParams.id;
                $scope.user = user;
                $scope.catalogType = catalog;

                // Model browser
                $scope.brandId = "";
                $scope.model = null;
                $scope.models = null;
                $scope.modelType = null;
                $scope.modelTypes = null;
                $scope.modelGrade = null;
                $scope.modelGrades = null;
                $scope.modelColor = null;
                $scope.modelColors = null;

                $scope.modelChandeRequest = null;

                // Load data
                $scope.loadData = function () {
                    return $http.get("/api/requests/search", {
                        params: {
                            retailerId: $scope.$storage.retailer.Id,
                            id: $scope.salesOrderRequestId
                        },
                        headers: {
                            Authorization: oidc.current.token_type + " " + oidc.current.access_token
                        }
                    }).then(function (response) {
                        if (Array.isArray(response.data) && response.data.length) {
                            console.log(response.data[0]);
                            $scope.modelChandeRequest = response.data[0];
                            $scope.brandId = $scope.modelChandeRequest.BrandId;


                            $scope
                                .loadModels(
                                    $scope.$storage.salesOrderRequestModel.modelId,
                                    $scope.$storage.salesOrderRequestModel.modelTypeId,
                                    $scope.$storage.salesOrderRequestModel.modelGradeId,
                                    $scope.$storage.salesOrderRequestModel.modelColorId
                                );
                        }
                    });
                };

                $scope.loadModels = function (modelId, modelTypeId, modelGradeId, modelColorId) {
                    $http
                        .get(`/api/${catalogApis[$scope.catalogType]}/model`, {
                            params: {
                                retailerId: $scope.$storage.retailer.Id,
                                brandId: $scope.brandId,
                                modelNameId: $scope.modelChandeRequest.ModelNameId
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $scope.models = response.data;
                            $scope.model = modelId !== null ? $scope.models.filter(function (item) { return item.Id === modelId; })[0] : $scope.models[0];

                            if ($scope.model === null) {
                                $scope.model = $scope.models[0];
                            }

                            $scope.loadModelTypes(modelTypeId, modelGradeId, modelColorId);
                        });
                };

                $scope.loadModelTypes = function (modelTypeId, modelGradeId, modelColorId) {
                    $http
                        .get(`/api/${catalogApis[$scope.catalogType]}/model-type`, {
                            params: {
                                modelId: $scope.model.Id,
                                countryId: $scope.$storage.retailer.CountryId
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $scope.modelTypes = response.data;
                            $scope.modelType = modelTypeId !== null ? $scope.modelTypes.filter(function (item) { return item.Id === modelTypeId; })[0] : null;

                            $scope.loadModelGrades(modelGradeId, modelColorId);
                        });
                };

                $scope.loadModelGrades = function (modelGradeId, modelColorId) {
                    if ($scope.modelType) {
                        $http
                            .get(`/api/${catalogApis[$scope.catalogType]}/model-grade`, {
                                params: {
                                    modelTypeId: $scope.modelType.Id,
                                    countryId: $scope.$storage.retailer.CountryId
                                },
                                headers: {
                                    Authorization: oidc.current.token_type + " " + oidc.current.access_token
                                }
                            })
                            .then(function (response) {
                                $scope.modelGrades = response.data;
                                $scope.modelGrade = modelGradeId !== null ? $scope.modelGrades.filter(function (item) { return item.Id === modelGradeId; })[0] : null;

                                $scope.loadModelColors(modelColorId);
                            });
                    } else {
                        $scope.modelGrade = null;
                        $scope.modelGrades = [];

                        $scope.loadModelColors(modelColorId);
                    }
                };

                $scope.loadModelColors = function (modelColorId) {
                    $http
                        .get(`/api/${catalogApis[$scope.catalogType]}/model-color`, {
                            params: {
                                brandId: $scope.brandId,
                                modelGenerationId: $scope.modelId,
                                modelTypeId: $scope.modelType ? $scope.modelType.Id : "",
                                modelGradeId: $scope.modelGrade ? $scope.modelGrade.Id : "",
                                countryId: $scope.$storage.retailer.CountryId
                            },
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $scope.modelColors = response.data;
                            $scope.modelColor = modelColorId !== null ? $scope.modelColors.filter(function (item) { return item.Id === modelColorId; })[0] : null;

                            $scope.browse();
                        });
                };

                $scope.isFreeCarsOnly = function () {
                    var result = true;
                    if ($scope.$storage.salesOrderRequestModel.switchFreeOrderedReserved === true) {
                        result = false;
                    }
                    return result;
                };

                $scope.browse = function () {
                    var params = {
                        retailerId: $scope.$storage.retailer.Id,
                        brandId: $scope.brandId,
                        modelId: $scope.model ? $scope.model.Id : "",
                        modelTypeId: $scope.modelType ? $scope.modelType.Id : "",
                        modelGradeId: $scope.modelGrade ? $scope.modelGrade.Id : "",
                        exteriorColorId: $scope.modelColor ? $scope.modelColor.ExteriorColorId : "",
                        countryId: $scope.$storage.retailer.CountryId,
                        freeCarsOnly: $scope.isFreeCarsOnly()
                    };

                    if ( $scope.catalogType === eta) {
                        params["freeCarsOnly"] = $scope.isFreeCarsOnly();
                    }

                    $http
                        .get(`/api/${catalogApis[$scope.catalogType]}/browse`, {
                            params: params,
                            headers: {
                                Authorization: oidc.current.token_type + " " + oidc.current.access_token
                            }
                        })
                        .then(function (response) {
                            $scope.list = response.data;
                        });
                };

                $scope.$watch("$storage.retailer", function (newValue, oldValue) {
                    if (newValue.Id !== oldValue.Id && newValue.Id > 0) {
                        $location.path("/sales-order-requests");
                    }
                });

                $scope.isCatalogType = function (catalog) {
                    return $scope.catalogType === catalog;
                };

                $scope.changeCatalogType = function (catalog) {
                    $scope.catalogType = catalog;
                    $scope.browse();
                };

                $scope.onModelChanged = function () {
                    $scope.$storage.salesOrderRequestModel.modelId = $scope.model ? $scope.model.Id : null;

                    $scope.loadModelTypes(null, null, $scope.modelColor ? $scope.modelColor.Id : null);
                };

                $scope.onModelTypeChanged = function () {
                    $scope.$storage.salesOrderRequestModel.modelTypeId = $scope.modelType ? $scope.modelType.Id : null;

                    $scope.loadModelGrades(null, $scope.modelColor ? $scope.modelColor.Id : null);
                };

                $scope.onModelGradeChanged = function () {
                    $scope.$storage.salesOrderRequestModel.modelGradeId = $scope.modelGrade ? $scope.modelGrade.Id : null;

                    $scope.loadModelColors($scope.modelColor ? $scope.modelColor.Id : null);
                };

                $scope.onModelColorChanged = function () {
                    $scope.$storage.salesOrderRequestModel.modelColorId = $scope.modelColor ? $scope.modelColor.Id : null;

                    $scope.browse();
                };

                $scope.onFreeOrderedReservedChanged = function () {
                    $scope.browse();
                };

                // Sorting
                $scope.sorting = function (orderName) {
                    if ($scope.$storage.salesOrderRequestModel.orderName === orderName) {
                        $scope.$storage.salesOrderRequestModel.orderDesc = !$scope.$storage.salesOrderRequestModel.orderDesc;
                    } else {
                        $scope.$storage.salesOrderRequestModel.orderName = orderName;
                        $scope.$storage.salesOrderRequestModel.orderDesc = false;
                    }
                };

                $scope.sortingClass = function (orderName) {
                    if ($scope.$storage.salesOrderRequestModel.orderName === orderName) {
                        if ($scope.$storage.salesOrderRequestModel.orderDesc) {
                            return "fa fa-caret-down";
                        } else {
                            return "fa fa-caret-up";
                        }
                    } else {
                        return "";
                    }
                };

                $scope.onFreeOrderedReservedChanged = function () {
                    $scope.browse();
                };

                // Add to order
                $scope.addToOrder = function (item) {
                    if ($scope.$storage.shoppingCart.some((item) => item.hasOwnProperty("fromSalesOrder") && item.fromSalesOrder.OrderLineId === $scope.modelChandeRequest.OrderLineId)) {
                        return $messageBox
                            .showConfirm("ShoppingCartSalesOrderFromRequestHeader", "ShoppingCartSalesOrderFromRequestContent", "ShoppingCartSalesOrderFromRequestBtn")
                            .result
                            .then(function () {
                                $location.path("/shopping-cart");
                            });
                    } else {
                        $shoppingCart.add({
                            type: "Model",
                            fromSalesOrder: $scope.modelChandeRequest,
                            data: item
                        });
                        $location.path("/shopping-cart");
                    }
                };

                if ($scope.$storage.retailer !== null && $scope.$storage.retailer.Id > 0) {
                    $scope.loadData();
                }
            }
        ]);
})();